// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Q5-z","dimensionLabel":"R5-z","styleChooserControlWrapper":"S5-z","styleChooserControl":"T5-z","disabled":"U5-z","giftCard":"V5-z","styleChooserText":"W5-z"};